export const servAddr = '/api/';



// WEBPACK FOOTER //
// ./src/servAddr.js